import { format } from 'date-fns';

export interface LocalMoment {
  localDate: string;
  localHour: number;
}

const LOCAL_DATE_FORMAT = 'yyyy-MM-dd';

export function readCurrentLocalMoment(now: Date = new Date()): LocalMoment {
  return { localDate: format(now, LOCAL_DATE_FORMAT), localHour: now.getHours() };
}
